<template lang="pug">
  .coverage(:class="signalIcon")
</template>

<script>
import { COVERAGE } from '@/app.config';

export default {
  props: {
    signal: {
      required: true,
    },
  },
  computed: {
    signalIcon() {
      switch (true) {
        case this.signal > COVERAGE.HIGHEST:
          return 'coverage--signal4';
        case this.signal > COVERAGE.HIGH:
          return 'coverage--signal3';
        case this.signal > COVERAGE.MEDIUM:
          return 'coverage--signal2';
        case this.signal > COVERAGE.LOW:
          return 'coverage--signal1';
        default:
          return '';
      }
    },
  },
};
</script>
